import React, { useContext, useState } from 'react';
import useStyles from '../../style/js-style/containers/roadmap/RoadmapStyle';
import i18next from 'i18next';
import { Box, Grid, Tab, Tabs, Typography, useTheme } from '@mui/material';
import clsx from 'clsx';
import EATabPanel from '../../components/common/EATabPanel';
import { roadmapItemsUtils, roadmapTabs } from './roadmapItemsUtils';
import MenuAppBar from '../../components/MenuAppBar';
import EAIcon from '../../components/common/EAIcon';
import RoadMapItemPopUp from './item/RoadMapItemPopUp';
import RoadMapItem from './item/RoadMapItem';
import { Context } from '../../states/Store';
import EAColorIcon from '../../components/common/EAColorIcon';

const a11yProps = (tabId) => {
  return {
    id: `${tabId}-tab`,
    "aria-controls": `${tabId}-tabpanel`,
  };
};

function RoadMap() {
  const [value, setValue] = useState("accomplished");
  const { classes } = useStyles();
  const [isOpenPopUp, setIsOpenPopUp] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [state] = useContext(Context);
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    const newId = event.target.id.substring(0, event.target.id.length - 4);
    setValue(newId);
  };

  const handleClickItem = (item) => {
    setSelectedItem(item);

    // Laisse un petit délais pour voir l'animation
    setTimeout(() => {
      setIsOpenPopUp(true);
    }, 100)
  }

  const handleClosePopUp = () => {
    setSelectedItem(null);
    setIsOpenPopUp(false);
  }

  const PopUpTitle = ({ selectedItem }) => {
    return (
      <div style={{fontSize: "18px"}}>
        <EAColorIcon
          icon={`/roadmap/${selectedItem.category}`}
          svgStyle={{ marginRight: '10px' }}
        />
        {selectedItem.title}
      </div>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      className={classes.root}
    >
      {/* AppBar Custom */}
      <div
        className={classes.appBar}
        style={{
          background: state.personalization.isCustomTemplate
            ? state.personalization.colorPrimary
            : theme.palette.primary.primary800,
        }}
      >
        <MenuAppBar variant="admin" />
      </div>

      {/* Header */}
      <div
        className={classes.headerWrapper}
        style={{
          background: state.personalization.isCustomTemplate
            ? state.personalization.colorPrimary
            : theme.palette.primary.primary800,
        }}
      >
        <Grid container className={classes.headerContent}>
          <EAIcon icon={state.personalization.isCustomTemplate ? 'roadmap/bg-aprovall_white' : 'roadmap/aprovall'} extension={state.personalization.isCustomTemplate ? "png" : "svg"} className={classes.headerLogo} />
          <Typography variant={'h2'} className={classes.title}>
            {i18next.t('roadmap.roadmap')}
          </Typography>
        </Grid>
      </div>

      <Grid
        item
        xs={12}
        style={{ padding: '0' }}
        className={classes.mainContentWrapper}
      >
        <Box className={classes.tabsWrapper}>
          <Tabs
            aria-label="dashboard tabs"
            value={value}
            onChange={handleChange}
          >
            {roadmapTabs.map((tab, index) => (
              <Tab
                key={tab.id}
                label={i18next.t(tab.label)}
                {...a11yProps(tab.id)}
                className={clsx(
                  classes.tab,
                  value === tab.id ? classes.selectedTab : classes.unselectedTab
                )}
              />
            ))}
          </Tabs>
        </Box>

        {roadmapTabs.map((tab, index) => (
          <EATabPanel
            key={tab.id}
            value={value}
            index={tab.id}
            className={classes.tabContentWrapper}
          >
            <>
              {/* Dislaimer */}
              <div className={classes.disclaimerWrapper}>
                <EAIcon icon={'/roadmap/lightbulb'} />
                <div>{i18next.t('roadmap.disclaimer')}</div>
              </div>


              {/* Liste des items */}
              <div className={classes.roadmapWrapper}>
                {roadmapItemsUtils(state.lang)[tab.id].map((item, index) => (
                  <RoadMapItem
                    item={item}
                    index={index}
                    tab={tab}
                    handleClickItem={handleClickItem}
                  />
                ))}
              </div>
            </>
          </EATabPanel>
        ))}
      </Grid>

      {isOpenPopUp && (
        <RoadMapItemPopUp
          item={selectedItem}
          onClose={handleClosePopUp}
          isOpen={isOpenPopUp}
          title={<PopUpTitle selectedItem={selectedItem}/> }
        />
      )}
    </Grid>
  );
}

export default RoadMap;
